import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { validationsQuestionsDynamiques } from 'src/app/shared/questionnaire.metadata';
import { ValidationService } from '../../../../shared/validation/validation.service';
import { FormulaireService } from '../../../formulaire.service';
import { ModeRenduService } from '../../../mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-lieux-asso',
  templateUrl: './lieux-asso.component.html',
  styleUrls: ['./lieux-asso.component.css']
})
export class LieuxAssoComponent implements OnInit, OnDestroy {
  public rootForm: UntypedFormGroup;
  step: number = 0;
  @Input()
  erreursMap: Map<string, string>;
  
  private subLieuxAsso: Subscription;
  private valeurTableauA4a_1: number[] = [];
  private valeurTableauA4a_2: number[] = [];
  private valeurTableauA4a_3: number[] = [];

  constructor(
    private formulaireService: FormulaireService,
    private validationService: ValidationService,
    public modeRenduService: ModeRenduService
  ) {
    this.rootForm = this.formulaireService.getRootForm();
    if (! this.lieuxAsso) {
      (this.rootForm.get('moyens') as UntypedFormGroup).setControl('lieuxAsso', new UntypedFormArray([]));
    }
   }

  ngOnInit(): void {
    setTimeout(() => {
        //Controles bloquants
        for (let index = 0; index < this.lieuxAsso.length; index++) {
          this.ajoutValidateurCroiseLieuxAsso(index);
          this.lieuxAsso.controls[index].updateValueAndValidity();
        }

        // Tri apres rechargement questionnaire
        this.trierLieuxAsso();
      
        // Calcul des totaux lieux asso
        this.subLieuxAsso = this.lieuxAsso.valueChanges.pipe(distinctUntilChanged(),debounceTime(100)).subscribe(valeur => {
            if (valeur instanceof Array) {

              this.valeurTableauA4a_1 = [];
              this.valeurTableauA4a_2 = [];
              this.valeurTableauA4a_3 = [];
              
              valeur.forEach((lieux, index) => {
                //Calcul totaux auto A4a
                this.calculAutoTotauxA4a(index, this.valeurTableauA4a_1, 'aaLieuAssoNbPerm', 'aaLieuAssoNbPermTot');      
                this.calculAutoTotauxA4a(index, this.valeurTableauA4a_2, 'aaLieuAssoNbPermEtp', 'aaLieuAssoNbPermEtpTot');      
                this.calculAutoTotauxA4a(index, this.valeurTableauA4a_3, 'aaLieuAssoNbVict', 'aaLieuAssoNbVictTot');      
              });
            }
          });
        this.lieuxAsso.updateValueAndValidity();

    }, 1000);
   
  }

  ngOnDestroy(): void {
    if (this.subLieuxAsso) {
      this.subLieuxAsso.unsubscribe();
    }
  }

  get lieuxAsso() {
    return this.rootForm.get('moyens').get('lieuxAsso') as UntypedFormArray;
  }

  public get formulaire(): UntypedFormGroup {
    return this.rootForm.get('moyens') as UntypedFormGroup;
  }

  public ajouterLieuxAsso() {
    // on récupère le nombre total avant ajout
    let nbLieux = this.formulaire.get('aaLieuAssoNb').value;

    // Pour les validators, on utilise ce qui est dans le questionnaire.metadata
    this.lieuxAsso.push(new UntypedFormGroup({
      aaLieuAssoRang: new UntypedFormControl(this.lieuxAsso.length, Validators.required),
      aaLieuAssoCodCom: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuAssoCodCom')),
      aaLieuAssoQp: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuAssoQp')),
      aaLieuAssoNbPerm: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuAssoNbPerm')),
      aaLieuAssoNbPermEtp: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuAssoNbPermEtp')),
      aaLieuAssoNbVict: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuAssoNbVict'))
    }));
    this.step = this.lieuxAsso.length - 1 ;
    this.ajoutValidateurCroiseLieuxAsso(this.lieuxAsso.length - 1);

    // on incrémente le nombre total de lieux
    this.formulaire.get('aaLieuAssoNb').setValue(++nbLieux);
  }

  private ajoutValidateurCroiseLieuxAsso (index: number) {
    const currentForm: UntypedFormGroup = this.lieuxAsso.controls[index] as UntypedFormGroup;
    currentForm.setValidators([
      this.validationService.ctrlA60Asso,
      this.validationService.ctrlA61Asso
    ]);
  }

  public supprimerLieuxAsso(index?: number) {
    if (index >= 0) {
      const lieuxValeur = this.lieuxAsso.controls[index].value;
      if (confirm(`Êtes vous sûr de supprimer ${lieuxValeur['aaLieuAssoCodCom']} ?`)) {
        this.lieuxAsso.removeAt(index);
      }
    } else {
      this.lieuxAsso.removeAt(this.lieuxAsso.length - 1);
    }
    // On maj les rangs
    this.majRangs();
    // on met à jour le nombre total de lieux
    this.formulaire.get('aaLieuAssoNb').setValue(this.lieuxAsso.controls.length);
  }

  public setStep(index: number): void {
    this.step = index;
  }

  private trierLieuxAsso(): void {
    this.lieuxAsso.controls.sort((a, b) => {
      if (a.get('aaLieuAssoRang').value < b.get('aaLieuAssoRang').value) {
            return -1;
      } else if (a.get('aaLieuAssoRang').value > b.get('aaLieuAssoRang').value) {
            return 1;
      } else {
            return 0;
      }
    });
  }

  private majRangs(): void {
    for (let index = 0; index < this.lieuxAsso.length; index++) {
      this.lieuxAsso.controls[index].get('aaLieuAssoRang').setValue(index);
    }
    this.trierLieuxAsso();
  }

  private calculAutoTotauxA4a(index: number, tabBoucle: number[], varBoucle: string, totBoucle: string): void {
      //console.log('valeur tot', this.lieuxAsso.controls[index].get(varBoucle).value)   ;       
    
      tabBoucle.splice(index,1,this.lieuxAsso.controls[index].get(varBoucle).value);
              let sum = tabBoucle.reduce((a,b)=>a+b,0);
              this.formulaire.get(totBoucle).setValue(sum);
  }

}
